import { IUserState } from '../types'

export const initialState: IUserState = {
  avdeling: {},
  region: {},
  me: {},
}
